import { IonImg, IonPage } from '@ionic/react'
import styled from 'styled-components'

export const Page = styled(IonPage)`
	position: relative;
	width: 100%;
	height: 100%;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const LogoText = styled(IonImg)`
	position: absolute;
	width: 165px;
	height: 60px;
	top: 25%;
	left: 50%;
	transform: translate3d(-50%, 0, 0);
	display: block;
`
